import { Immutable } from "immer";
import React from "react";
import { TempurLoveBreadcrumbs } from "tsi-common-react/src/components/TempurLoveBreadcrumbs/index";
import { TempurLoveGrid } from "tsi-common-react/src/components/TempurLoveGrid/index";

import { templates } from "@reactivated";

type IProps = Immutable<templates.TempurLoveGridTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <>
            {props.breadcrumb_items && (
                <TempurLoveBreadcrumbs
                    items={props.breadcrumb_items}
                    className="al-tlovegrid-breadcrumbs"
                    useCappedWidth={false}
                    wrapperClassName="tempurlove-breadcrumbs"
                />
            )}
            <div className="l-full-width tempurlove-content">
                <TempurLoveGrid
                    baseApiUrl={props.base_api_url}
                    filterBy={props.filter_by}
                    initialGridData={props.initial_grid_data}
                    initialNextUrl={props.initial_next_url}
                    useCappedWidth={false}
                    rootUrl={props.root_url}
                />
            </div>
        </>
    );
};
